import ErrorUtils from 'utils/error-utils';
import StorageUtils from '@spothero/utils/storage';
import { StorageKeys } from 'common/constants/storageKeys';
export const NEW_VISITOR = 'n';
export const _getVisitorTypeCookieValueInBrowser = () => {
    try {
        const cookieValue = StorageUtils.get(StorageKeys.VISITOR_TYPE, 'cookie')?.toString() ||
            '';
        return cookieValue;
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Failed to get visitor type cookie value in browser',
        });
        return '';
    }
};
export const isReturningUser = () => {
    const newUserCookieValue = _getVisitorTypeCookieValueInBrowser();
    if (newUserCookieValue === NEW_VISITOR) {
        return false;
    }
    return true;
};
export const isNewUser = () => {
    return !isReturningUser();
};
